import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

//* Components
import { LoginComponent } from './components/login/login.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { AuthComponent } from './page/auth.component';

//* Services
import { AuthService } from './services/auth.service';

//* Routing
import { AuthRoutingModule } from './auth-routing.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginLoadingComponent } from './components/loading/loading.component';
import { RequestSupportButtonComponent } from './components/request-support-button/request-support-button.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { TermsBottomSheetComponent } from './components/terms-bottom-sheet/terms-bottom-sheet.component';

@NgModule({
	declarations: [
		AuthComponent,
		LoginComponent,
		LoginLoadingComponent, 
		SponsorsComponent,
		ResetPasswordComponent,
		ChangePasswordComponent,
		TermsBottomSheetComponent,
		RequestSupportButtonComponent
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MaterialModule,
		AuthRoutingModule,
	],
	exports: [],
	providers: [AuthService],
})
export class AuthModule { }
